import React from 'react';
import { gettext } from '@eventbrite/i18n';
import FacebookIconSvg from './icons/FacebookIcon';

import { Button } from '@eventbrite/eds-button';
import { Icon } from '@eventbrite/eds-icon';
import { SIZE_BLOCK, STYLE_NEUTRAL } from '@eventbrite/eds-button';

import { LogoFacebookColor } from '@eventbrite/eds-iconography';

import { DATA_HEAP_ID_LOGIN_WITH_FACEBOOK_BUTTON } from './constants';

const FacebookLogo = () => (
    <div className="facebook-button__logo eds-g-cell">
        <div className="eds-align--left">
            <Icon type={<LogoFacebookColor />} size="small" />
        </div>
    </div>
);

const ConnectedUserButton = ({
    dataAutomation,
    handleOnClick,
    firstName,
    pictureUrl,
}) => (
    <div className="facebook-button-container social-login__container">
        <Button
            data-automation={dataAutomation}
            data-heap-id={DATA_HEAP_ID_LOGIN_WITH_FACEBOOK_BUTTON}
            type="button"
            size={SIZE_BLOCK}
            onClick={handleOnClick}
            style={STYLE_NEUTRAL}
        >
            <div className="facebook-button__content eds-align--center">
                <FacebookLogo />

                <div className="facebook-button__text eds-g-cell">
                    {gettext('Continue as %(firstName)s ', {
                        firstName,
                    })}
                </div>
                <div className="eds-g-cell facebook-button__image-wrapper">
                    <div className="eds-align--center">
                        <img
                            className="facebook-button__image"
                            src={pictureUrl}
                            alt={pictureUrl}
                        />
                    </div>
                </div>
            </div>
        </Button>
    </div>
);

const StandardButton = ({ dataAutomation, handleOnClick, buttonText }) => (
    <div className="facebook-button-container social-login__container">
        <Button
            data-automation={dataAutomation}
            data-heap-id={DATA_HEAP_ID_LOGIN_WITH_FACEBOOK_BUTTON}
            type="button"
            size={SIZE_BLOCK}
            onClick={handleOnClick}
            style={STYLE_NEUTRAL}
        >
            <div className="facebook-button__content eds-align--center">
                <FacebookLogo />

                <div className="facebook-button__text eds-g-cell ">
                    {buttonText}
                </div>
            </div>
        </Button>
    </div>
);

const SecondaryButton = ({ dataAutomation, handleOnClick, buttonText }) => (
    <Button
        type="button"
        style="none"
        data-automation={dataAutomation}
        data-heap-id={DATA_HEAP_ID_LOGIN_WITH_FACEBOOK_BUTTON}
        onClick={handleOnClick}
    >
        <Icon type={<FacebookIconSvg />} isBlockLevel={true} size="medium" />
        <div className="eds-is-hidden-accessible">{buttonText}</div>
    </Button>
);

const ContinueWithFacebookButton = ({
    accessToken,
    picture,
    firstName,
    handleOnClick,
    buttonFBText,
    isSecondary,
}) => {
    let component = null;
    const dataAutomation = 'facebook-login-button';
    const buttonText = buttonFBText || gettext('Continue with Facebook');
    if (isSecondary) {
        component = (
            <SecondaryButton
                dataAutomation={dataAutomation}
                handleOnClick={handleOnClick}
                buttonText={buttonText}
            />
        );
    } else if (accessToken) {
        component = (
            <ConnectedUserButton
                dataAutomation={dataAutomation}
                handleOnClick={handleOnClick}
                firstName={firstName}
                pictureUrl={picture?.data?.url || ''}
            />
        );
    } else {
        component = (
            <StandardButton
                dataAutomation={dataAutomation}
                handleOnClick={handleOnClick}
                buttonText={buttonText}
            />
        );
    }
    return component;
};

export default ContinueWithFacebookButton;
